/**
 * The Overview's own control words (twin slice 1, plan W4 step 10), kept
 * out of the screen so the components file exports only components. Copy
 * for review (plan gate B).
 */
export const OVERVIEW_WORDS = {
  map: 'Map',
  building: 'Building',
  viewGroup: 'View',
  floor: 'Floor',
  wholeBuilding: 'Whole building',
  back: 'Back',
  switchedSite: (label: string) => `Switched to ${label} for this link.`,
  noSiteAccess: "This link is for a site you don't have access to.",
  /** The 2D map would not load (copy deck v2, N7): plain words for every
   *  reader; ops get the error itself, collapsed under `details`. */
  mapLoadErrorTitle: "Can't load the building map right now",
  mapLoadErrorText: 'Try again in a minute.',
  /** Said under it when the last good map is still drawn below. */
  mapLoadErrorStale: 'The map below may be out of date.',
  details: 'Details',
} as const;
